import { Grid, makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles({
    propertyName: {
        fontWeight: 'bold',
    },
});

const PointTooltip = ({ latitud, longitud, nivel, punto , historic=true }) => {
    const classes = useStyles();

    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="h6">{punto}</Typography>
            </Grid>
            <Grid item xs={12}>
                <span className={classes.propertyName}>Coordenadas: </span>
                {`${latitud}, ${longitud}`}
            </Grid>
{/*             {historic &&
              <Grid item xs={12}>
                    <span className={classes.propertyName}>Nivel: </span>
                    {nivel}
                </Grid>
            } */}
            
        </Grid>
    );
};

PointTooltip.propTypes = {
    latitud: PropTypes.number,
    longitud: PropTypes.number,
    nivel: PropTypes.number,
    punto: PropTypes.string,
    historic: PropTypes.bool,
};

export default PointTooltip;
